import React from 'react';
import './AnimatedEllipses.scss';
/**
 * AnimatedEllipsis
 * @return {ReactElement} HTML markup
 */
const AnimatedEllipsis = () => (
  <div
    className='bf-vcf-animated-ellipsis-animate'
    data-testid='bf-vcf-animated-ellipsis-container'>
    <div className='bf-vcf-animated-ellipsis-bounce1' />
    <div className='bf-vcf-animated-ellipsis-bounce2' />
    <div className='bf-vcf-animated-ellipsis-bounce3' />
  </div>
);
export default AnimatedEllipsis;